exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1O6PZ {\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_1O6PZ"
};